<template>
	<div id="payresult">
		<div class="main">
		  <div v-if="success == 1">
			<img src="../assets/payright.jpg" style="width:50vw;margin:auto;display:block;margin-top:0vw;"/>
			<div style="color:#9a0000;font-size:8vw;margin-top:3vw;font-weight:bold;text-align:center;">支付成功</div>
			<div style="color:#cccccc;font-size:4vw;margin-top:10vw;font-weight:bold;text-align:center;">订单号：{{order_sn}}</div>
			<div style="width:94vw;height:12vw;line-height:12vw;text-align:center;font-size:4.8vw;background-color:#2cd5ff;border-radius:10px;color:#FFFFFF;margin:auto;margin-top:10vw;" v-on:click="event_back">返回</div>
		  </div>
		  <div v-if="success == 0">
			<img src="../assets/paywrong.jpg" style="width:50vw;margin:auto;display:block;margin-top:0vw;"/>
			<div style="color:#DDDDDD;font-size:8vw;margin-top:3vw;font-weight:bold;text-align:center;">支付失败</div>
			<div style="color:#cccccc;font-size:4vw;margin-top:4vw;font-weight:bold;text-align:center;">订单号：{{order_sn}}</div>
			<div style="width:94vw;height:12vw;line-height:12vw;text-align:center;font-size:4.8vw;background-color:#2cd5ff;border-radius:10px;color:#FFFFFF;margin:auto;margin-top:10vw;" v-on:click="event_back">返回</div>
		  </div>
		</div>
	</div>
</template>

<script>
export default {
	data () {
		return {
			success:2,
			order_sn:''
		}
	},
	created (){
		var order_sn = this.$route.query.order_sn;
		var type = this.$route.query.type;
		var wx = this.$wx;
		var app = this.$app;
		wx.showLoading({
			title: '等待支付结果',
		});
		app.pr('/api/common/checkstatus', {
			order_sn: order_sn,
			type:type
		}).then((res) => {
			wx.hideLoading();
			this.setData({
				success: 1,
				order_sn: order_sn
			});
			//更新用户信息
			app.reloadUser();
		}).catch((res) => {
			wx.hideLoading();
			this.setData({
				success: 0,
				order_sn: order_sn
			});
		});
	},
	computed: {
	},
	methods:{
		setData(params){
			for(var n in params){
				this[n] = params[n]
			}
		},
		event_back(){
			this.$router.back(-1)
		}
	}
}
</script>
<style scoped>
#payresult{
	background-color:#ffffff;
	min-height:100vh;
	padding-top:20vw;
}
</style>


// WEBPACK FOOTER //
// src/components/Payresult.vue